module.exports = __WEBPACK_EXTERNAL_MODULE_221__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/observable/timer"
// module id = 221
// module chunks = 0